import { createAction } from '@reduxjs/toolkit';

export const timerStartRequested = createAction<{
  totalSeconds: number;
}>('timer/startRequested');

export const timerStopRequested = createAction('timer/stopRequested');

export const timerPauseRequested = createAction('timer/pauseRequested');
export const timerResumeRequested = createAction('timer/resumeRequested');
